module.exports = __webpack_public_path__ + "img/logo1.0b3d49fa.png";